import axios from 'axios';
import { router } from '@inertiajs/react';
import { useState, useRef } from 'react';

import Editor from './Editor';
import Quill from 'quill';


const Comment = ({ comment, user, type }) => {

    const [isHidden, setIsHidden] = useState(comment.level === -1);
    const [isEditing, setIsEditing] = useState(false);
    const [editedMessage, setEditedMessage] = useState(comment.message);
    const bgClass = comment.level === -1 ? 'bg-gray-200' : 'bg-white';
    const canEditClass = comment.can_edit === true ? 'cursor-pointer' : '';

    const quillRef = useRef();
    const noToolbarsPlease = { toolbar: [] };

    const handleLetterClick = () => {
        router.visit(route('letter.details', {id: comment.letter_id}));
    }

    const toggleCommentVisibility = () => {
        const url = isHidden
            ? `/comments/${comment.id}/show`
            : `/comments/${comment.id}/hide`;

        axios.patch(url)
            .then(response => {
                setIsHidden(!isHidden);
                console.log(response.data.message);
                //window.location.reload();
                router.reload();
            })
            .catch(error => {
                console.error("There was an error updating the comment visibility!", error);
            });
    };    

    const handleEditClick = () => {
        if (comment.can_edit) {
            setIsEditing(true);
            quillRef.current.clipboard.dangerouslyPasteHTML(comment.message, 'silent');
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setEditedMessage(comment.message); // Reset to original message if canceled
    };

    const handleSaveClick = () => {

        const txt = JSON.stringify(quillRef.current.getSemanticHTML());
        axios.patch(`/comments/${comment.id}`, { message: txt })
            .then(response => {
                setIsEditing(false);
                router.reload(); // Reload or you can directly update the comment state if you want to avoid a full reload
            })
            .catch(error => {
                console.error("There was an error saving the comment!", error);
            });
    };    

    const handleReport = () => {

        router.post(route('report.index'), {id: comment.id, type: "comment"});

    }            

    const handleDetailsClick = () => {

        router.visit(route('activity.details', {ip: comment.ip}));
    }

    return (
      <div key="commentContainer-{comment.id}" className={`letterContainer py-[5px] my-[5px] px-[10px] ${bgClass}`}>
        <div key="commentHeader-{comment.id}" className="flex flex-row border-b-[1px] border-black border-dotted">
                <div className="flex-1">
                    <span className="font-bold">

                        {comment.guid.startsWith("mod") ? (
                            <>

                                <svg xmlns="http://www.w3.org/2000/svg" 
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className={`relative pl-[2px] top-[-2px] inline w-[14px] md:w-[15px] text-pink`}
                                >
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                                </svg> moderator

                                <img src='/images/heart.png' alt="heart" className="inline-block w-4 h-4 mr-1 hidden" />
                            </>
                        ) : (
                            comment.name
                        )}

                        {/* Conditionally render the "hide" link if the cookie matches */}
                        {comment.can_edit && (
                            <a onClick={toggleCommentVisibility} className="cursor-pointer pl-[5px] active:underline font-normal">{isHidden ? "show" : "hide"}</a>
                        )}

                    </span>

                    {type == 'list' && (
                        <span><a onClick={handleLetterClick} className="text-pink px-2">letter #{comment.letter_id}</a></span>
                    )}

                </div>
                
                <div className="content-center flex flex-row">

                        <div className="content-center">{comment.date}</div>

                        <div className="content-center">

                            <a className="ml-2 text-pink reportLink relative top-[-2px]" onClick={handleReport}>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor" className="text-pink  w-[10px] inline">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
                                </svg>

                            </a>


                        </div>

                </div>            
        </div>

                <div className={`commentMessageHolder ${isEditing ? '' : 'hidden'}`}>
                    <Editor
                        modules={noToolbarsPlease}
                        ref={quillRef}
                    >
                    </Editor>                    
                    <div className="flex space-x-2 mt-2">
                        <button onClick={handleCancelClick} className="bg-gray-500 text-white px-2 py-1 rounded">Cancel</button>
                        <button onClick={handleSaveClick} className="bg-pink text-white px-2 py-1 rounded">Save</button>
                    </div>
                </div>
                <div
                    className={`${isEditing ? 'hidden' : ''} commentMessage break-words py-[10px] ${canEditClass}`}
                    onClick={handleEditClick}
                    dangerouslySetInnerHTML={{ __html: comment.message }}
                />
                {/* comment subnavigation */}
                <div>

                    {user?.l == 1 && (
                        <>
                            <span className="text-gray-300 text-xs">
                                {comment.ip}
                            </span>
                        </>
                    )}

                    {user?.l == 2 && (
                        <>
                            <span className="text-gray-300 text-xs">
                                <a onClick={handleDetailsClick}>
                                    {comment.ip}
                                </a>
                            </span>
                        </>
                    )}


                </div>

      </div>    
    ); 
  };

export default Comment;